import { ProposalAnalysesContent } from '@/features/proposal-analyses/components';
import { Page, PageHeader } from '@/shared/ui/page';
import { requireInsurerUnderwritingAccess, requirePermissions } from '@/shared/utils';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { Home } from 'lucide-react';

export const Route = createFileRoute('/_app/proposal-analyses/')({
  component: RouteComponent,
  beforeLoad: async () => {
    const [hasPermission, hasUnderwritingAccess] = await Promise.all([
      requirePermissions(['policies.proposals.read']),
      requireInsurerUnderwritingAccess(),
    ]);
    if (!hasPermission || !hasUnderwritingAccess) {
      throw redirect({ to: '/dashboard' });
    }
  },
});

function RouteComponent() {
  return (
    <Page.Root>
      <Page.Breadcrumb
        items={[
          {
            label: 'Pagina Inicial',
            href: '/dashboard',
            iconLeft: <Home className='h-4 w-4' />,
          },
          { label: 'Subscrição' },
          { label: 'Propostas em Análise', active: true },
        ]}
      />

      <PageHeader.Root>
        <PageHeader.Main>
          <PageHeader.TitleGroup>
            <PageHeader.Title>Propostas em Análise</PageHeader.Title>
            <PageHeader.Subtitle>
              Acompanhe, envie e gerencie as análises vinculadas as propostas
            </PageHeader.Subtitle>
          </PageHeader.TitleGroup>
        </PageHeader.Main>
      </PageHeader.Root>

      <ProposalAnalysesContent />
    </Page.Root>
  );
}
